<template>
  <div ref="bienvenidaRef" class="bienvenida-section">

    <!-- ENCABEZADO -->
    <div ref="encabezadoRef" class="encabezado-container">

      <p class="encabezado-fecha">
        05.DICIEMBRE.2026<br>
        – CIUDAD DE MÉXICO.
      </p>

      <br>

      <h2 class="encabezado-nombres">

        <span class="nombre-principal">
          JAZMÍN RUBÍ
        </span>

        <br>

        <span class="apellidos-novios">
          Arzate Navarro
        </span>

        <br>

        <div class="separador-central">
          <div class="ampersand">&</div>
        </div>

        <span class="nombre-principal">
          ALAN ADAHIR
        </span>

        <br>

        <span class="apellidos-novios">
  Pérez
  <span class="g-especial">G</span>onzález
</span>

      </h2>

    </div>

    <div class="bienvenida-container">

      <!-- TEXTO PRINCIPAL -->
      <div ref="textoPrincipalRef" class="frase-container">

        <p class="bienvenida-text">
          {{ mensaje }}
        </p>

        <!-- AUTOR -->
        <p ref="autorRef" class="autor-frase">
          — Jean-Paul Sartre
        </p>

      </div>

      <!-- NOS CASAMOS -->
      <p ref="nosCasamosRef" class="textmia">
        {{ mensajeFinal }}
      </p>

      <!-- SECCIÓN PADRES -->
      <div ref="padresContainerRef" class="padres-container">

        <!-- FRASE -->
        <p
          ref="bendicionRef"
          class="bienvenida-text bendicion-text"
        >
        </p>

        <!-- PADRES -->
        <h3
          class="padres-titulo"
          ref="padresTituloRef"
        >Con la bendición de Dios y de 
          <br>
          NUESTROS PADRES
        </h3>
<br>
        <p
          v-for="(padre, i) in listaPadres"
          :key="'padre-' + i"
          class="padres-nombre"
          :ref="el => { if (el) padresRefs[i] = el }"
        >
          {{ padre }}
        </p>

        <!-- PADRINOS -->
        <!--
        <h3 class="padres-titulo" ref="padrinosTituloRef">
          <br />
          PADRINOS DE VELACIÓN
        </h3>

        <p
          v-for="(padrino, j) in listaPadrinos"
          :key="'padrino-' + j"
          class="padres-nombre"
          :ref="el => { if (el) padrinosRefs[j] = el }"
        >
          {{ padrino }}
        </p>
        -->

      </div>

    </div>

  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {

  name: 'BienvenidaPage',

  setup() {

    const bienvenidaRef = ref(null)

    const encabezadoRef = ref(null)

    const textoPrincipalRef = ref(null)

    const autorRef = ref(null)

    const nosCasamosRef = ref(null)

    const padresTituloRef = ref(null)

    const padrinosTituloRef = ref(null)

    const padresContainerRef = ref(null)

    const padresRefs = ref([])

    const padrinosRefs = ref([])

    const bendicionRef = ref(null)

    const mensaje = ref('')

    const mensajeFinal = ref('')

    const listaPadres = [
      'Carlos Agustín Arzate Martínez',
      'Patricia Navarro Pérez',
      '&',
      'Alberto Pérez López',
      'Verónica González Ayala'
    ]

    const listaPadrinos = [
      'Mirna Álvarez Armijo',
      'Romualdo Rodríguez de León'
    ]

    const text =
      'Con el amor de las personas consagramos nuestra vida a otra persona, nuestra felicidad será la felicidad de ambos y nuestra pena será la pena de ambos'

    const textFinal = '¡Nos Casamos!'

    onMounted(async () => {

      await nextTick()

      gsap.set([
        encabezadoRef.value,
        textoPrincipalRef.value,
        autorRef.value,
        nosCasamosRef.value,
        bendicionRef.value,
        padresTituloRef.value,
        padrinosTituloRef.value,
        ...padresRefs.value,
        ...padrinosRefs.value
      ], {
        opacity: 0,
        y: 40
      })

      const observer = new IntersectionObserver(

        (entries, observer) => {

          entries.forEach(entry => {

            if (entry.isIntersecting) {

              const tl = gsap.timeline({
                defaults: {
                  duration: 1,
                  ease: 'power2.out'
                }
              })

              tl.to(
                encabezadoRef.value,
                {
                  y: 0,
                  opacity: 1
                },
                0
              )

              .add(() => {
                mensaje.value = text
              })

              .to(
                textoPrincipalRef.value,
                {
                  y: 0,
                  opacity: 1
                },
                '>-0.5'
              )

              // AUTOR
              .to(
                autorRef.value,
                {
                  y: 0,
                  opacity: 1,
                  duration: 0.8
                },
                '>-0.7'
              )

              .add(() => {
                mensajeFinal.value = textFinal
              })

              .to(
                nosCasamosRef.value,
                {
                  y: 0,
                  opacity: 1
                },
                '>-0.3'
              )

              // BENDICIÓN
              .to(
                bendicionRef.value,
                {
                  y: 0,
                  opacity: 1
                },
                '>-0.35'
              )

              // PADRES
              .to(
                padresTituloRef.value,
                {
                  y: 0,
                  opacity: 1
                },
                '>-0.3'
              )

              .to(
                padresRefs.value,
                {
                  y: 0,
                  opacity: 1,
                  stagger: 0.25
                },
                '>-0.15'
              )

              // PADRINOS
              .to(
                padrinosTituloRef.value,
                {
                  y: 0,
                  opacity: 1
                },
                '>-0.2'
              )

              .to(
                padrinosRefs.value,
                {
                  y: 0,
                  opacity: 1,
                  stagger: 0.25
                },
                '>-0.1'
              )

              observer.unobserve(entry.target)
            }
          })
        },

        {
          threshold: 0.5
        }
      )

      if (bienvenidaRef.value) {
        observer.observe(bienvenidaRef.value)
      }
    })

    return {

      bienvenidaRef,

      encabezadoRef,

      textoPrincipalRef,

      autorRef,

      nosCasamosRef,

      padresTituloRef,

      padrinosTituloRef,

      padresContainerRef,

      padresRefs,

      padrinosRefs,

      bendicionRef,

      mensaje,

      mensajeFinal,

      listaPadres,

      listaPadrinos
    }
  }
}
</script>

<style scoped>

.small-cross {
  font-size: 0.8em;
  color: #a17e4e;
  margin-left: 4px;
}

.bienvenida-section {

  padding: 30px 0;

  background-image: url('@/assets/7.png');

  background-size: cover;

  background-position: center;

  background-repeat: no-repeat;
}

.encabezado-container {

  text-align: center;

  margin-top: 30px;

  margin-bottom: 20px;

  opacity: 0;

  transform: translateY(50px);
}

.encabezado-fecha {

  font-family: 'Karla', sans-serif;

  font-size: 14px;

  color: #555;

  letter-spacing: 1px;

  text-transform: uppercase;

  margin-bottom: 10px;
}

.encabezado-nombres {

  font-family: 'Playfair Display', serif;

  font-size: 32px;

  font-weight: bold;

  color: #1e1e1e;

  line-height: 1.2;
}

.nombre-principal {

  font-family: 'nombres';

  font-weight: 400;
}

.apellidos-novios {

  font-size: 30px;

  font-family: "Hearth Stone", sans-serif;

  font-weight: 400;

  line-height: 1.5;

  color: #9b9898;
}

.bienvenida-container {

  text-align: center;

  padding: 30px 20px;

  display: flex;

  flex-direction: column;

  align-items: center;
}

/* CONTENEDOR FRASE */
.frase-container {

  max-width: 700px;

  position: relative;

  opacity: 0;
}

/* TEXTO */
.bienvenida-text {

  font-size: 18px;

  line-height: 1.9;

  font-family: 'padres';

  color: #333;

  margin: 20px 0;

  white-space: pre-line;

  opacity: 1;
}

/* AUTOR */
.autor-frase {

  width: 100%;

  text-align: right;

  font-size: 14px;

  font-family: 'Karla', sans-serif;

  letter-spacing: 1px;

  color: #272626;

  margin-top: -5px;

  padding-right: 10px;

  opacity: 0;
}

/* NOS CASAMOS */
.textmia {

  font-family: "say2";

  font-size: 26px;

  color: #302f2d;

  margin-top: 35px;

  opacity: 0;
}

/* BENDICIÓN */
.bendicion-text {

  margin-top: 10px;

  margin-bottom: 10px;
}

/* PADRES */
.padres-container {

  margin-top: 20px;

  text-align: center;
}
.g-especial{
  font-family: 'Great Vibes', cursive;
  font-size: 52px;
  color: #aea8a8;
  display: inline-block;
  transform: rotate(-8deg) translateY(5px);
  margin-right: -6px;
  margin-left: 2px;
  font-weight: 100;
  line-height: 0;
}
.padres-titulo {

  font-family: 'Playfair Display', serif;

  font-size: 22px;

  font-weight: 500;

  color: #1e1e1e;

  line-height: 1.5;

  margin-bottom: 20px;

  letter-spacing: 1px;
}

.padres-nombre {

  font-family: 'padres', serif;

  font-size: 19px;

  color: #444;

  margin-bottom: 8px;

  opacity: 0;
}

.separador-central {

  text-align: center;

  margin: 10px 0;
}

.ampersand {

  font-size: 30px;

  line-height: 0.8;

  color: rgb(93, 89, 89);

  opacity: 0.25;

  margin-top: 18px;

  margin-bottom: 18px;

  font-family: 'padres', serif;
}

</style>